import { Directive, TemplateRef, viewChild } from '@angular/core';
import { BaseViewComponent } from './base-view.component';

@Directive()
export abstract class AnnouncementBaseViewComponent extends BaseViewComponent {

    readonly announcementTitleTemplate = viewChild<TemplateRef<any>>('announcementTitleTemplate');
    readonly announcementTextTemplate = viewChild<TemplateRef<any>>('announcementTextTemplate');
    readonly announcementButtonGroupTemplate = viewChild<TemplateRef<any>>('announcementButtonGroupTemplate');
}
